module.exports = __webpack_public_path__ + "img/ideal.3c79021.png";